var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"Btn",attrs:{"type":_vm.type,"value":_vm.value,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),(_vm.loader)?_c('static-loader'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }